<section class="maintenance-page">
  <img src="assets/dashboard/logoApp.svg" alt="AutoInsight logo" class="brand-logo" />

  <main class="maintenance-panel">
    <div class="panel-head">
      <button
        type="button"
        class="back-btn"
        (click)="goBack()"
        [attr.aria-label]="isMechanicReview ? 'Back to reservations' : 'Back to dashboard'">&#8592;</button>
      <h1>Maintenance</h1>
    </div>

    <p class="status-message" *ngIf="loading && parts.length === 0">Loading maintenance parts...</p>
    <p class="status-message info" *ngIf="!loading && !errorMessage && infoMessage">{{ infoMessage }}</p>
    <p class="status-message error" *ngIf="!loading && errorMessage">{{ errorMessage }}</p>
    <p class="status-message" *ngIf="!loading && !errorMessage && !infoMessage && parts.length === 0">
      No maintenance parts are available for the selected vehicle.
    </p>

    <div class="table-shell" *ngIf="parts.length > 0">
      <table class="parts-table">
        <thead>
          <tr>
            <th>Part</th>
            <th>Durability</th>
            <th>Previous</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let part of parts">
            <td>
              <button
                class="part-link"
                type="button"
                (click)="openPart(part)"
                [disabled]="isMechanicReview">
                {{ part.name }}
              </button>
            </td>
            <td>{{ part.durabilityPercent }}%</td>
            <td>{{ part.previousServiceLabel }}</td>
            <td>{{ part.status }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </main>
</section>
